<template>
  <div :class="{'open':true, 'opened':open}" @click.prevent="open=!open" v-scroll-lock="open">
  	<span class="cls"></span>
  	<span>
			<div class="burger">
					<navigation class="sub-menu vertical burger-nav" :menu="1"></navigation>
			</div>
  	</span>
  	<span class="cls"></span>
  </div>
</template>

<script>
import Navigation from "@/components/elements/Navigation.vue"

export default {
	components: {  Navigation },
  data () {
    return {
				open:false,
    }
  },
  methods: {
		close: function() {
      var vm=this;
			vm.open=false;
		}
  },
	watch:{
		open: function(open){
      var vm=this;
      vm.$event.$emit('userinteraction', {item:'burger menu', from:this.$route.path});
			vm.$event.$emit('blur', open);
		}
	},
	mounted: function() {
		this.$event.$on('close', this.close);
	}
}
</script>

<style lang="scss" scoped>
@import '../../sass/variables';

$burger-width-height: 220vh;

.inverted {
	.open > span:first-of-type, .open > span:last-of-type,{
		background-color: black;
	}
	.open > span:not(:first-of-type), .open > span:not(:last-of-type),{
		background-color: black;
	}
	.open.opened > span:first-of-type, .open.opened > span:last-of-type,{
		background-color: white;
	}

}

.open{
	@include for-size(phone-only) {
		display:block;
	}
	display: none;
	width: 2em;
	height: 1.4em;
	cursor: pointer;
	transition: opacity 0.2s linear;
	position: relative;
	padding:0;
	&:hover{
		opacity: 1;
	}
	span{
		display: block;
		height: 1vw;
		width: inherit;
		border-radius: 100vw;
		background-color: #f0f0f0;
		position: absolute;
		left: 0%;
		top: 0%;
		margin:0 auto;
		overflow: hidden;
		transition: all 0.4s ease-out;
		will-change: width, height, opacity;
		box-sizing: border-box;
		&:nth-child(1){
			margin-top: 0vw;
			z-index: 9;
		}
		&:nth-child(2){
			margin-top: 2vw;
		}
		&:nth-child(3){
			margin-top: 4vw;
		}
	}
}
.burger {
	transition: opacity 0.8s cubic-bezier(0.68, -0.55, 0.265, 1.55);
	position: relative;
	height:100%;
	width:100%;
	//background-image:url(/static/img/burger_bg.png);
	background-size:102%;
	background-repeat: no-repeat;
	border-radius: inherit;
	background-position: center;
	opacity: 0;
	overflow: hidden;
	&:before {
    content:"";
    height:100%;
    width:100%;
    position: absolute;
    background:linear-gradient(to bottom, $dark-blue-bg 0%,rgba(0,0,0,0) 100%);
  }
	@keyframes iss{
		from {
			transform: translate(0,0);
		}
		to {
			transform: translate($burger-width-height,$burger-width-height);
		}
	}
}
.sub-menu{
		transition: opacity 0.4s ease;
		position: relative;
		z-index: 18;
		opacity: 0;
		pointer-events: none;
		position: fixed;
    top: 0;
    left: 0;
	}

	.opened{
		.burger{
			opacity: 1;
			transition: all 0.8s cubic-bezier(0.68, -0.55, 0.265, 1.55);
			.sub-menu{
					opacity: 1;
					transition: opacity 0.4s ease;
					pointer-events: auto;
				}
		}
		span:nth-child(2){
			overflow: visible;
		}
		span:nth-child(1), span:nth-child(3){
			z-index: 100;
			transform: rotate(45deg);
			transform-origin: bottom center;
		}
		span:nth-child(1){
			transform: rotate(45deg) translateY(3.2vw);
		}
		span:nth-child(2){
			height: $burger-width-height;
			width: $burger-width-height;
			left: -140vw;
    	top: -140vw;
      background-color: rgba(255,255,255,0);
		}
		span:nth-child(3){
			transform: rotate(-45deg) translateY(-2.5vw);
		}
		li{
			margin-right: 168px;
		}
	}


</style>



// WEBPACK FOOTER //
// src/components/elements/BurgerMenu.vue